/*
    UI komponenta akordionu

    Povinné data atributy example:
   
    <ul class="accordion" data-accordion>
            <li class="accordion__item" data-accordion-item>
                <div class="accordion__question" data-accordion-item-title>{{ item.question }}</div>
                <div class="accordion__answer" data-accordion-item-content>{{ item.answer | raw }}</div>
            </li>
    </ul>
  
*/

export const Accordion = (accordionList: NodeListOf<HTMLDivElement>): void => {
  accordionList.forEach((item) => {
    const title: NodeListOf<HTMLElement> = item.querySelectorAll('[data-accordion-item-title]');
    // CSS třída pro otevřený akordion
    const TOGGLE_CLASS = 'item--opened';

    // Změna viditelnosti tématu
    title.forEach((titleElement) => {
      titleElement.addEventListener('click', (evt: Event) => {
        evt.preventDefault();
        const itemElement: HTMLDivElement | null = titleElement.closest('[data-accordion-item]');

        if (!itemElement) return;

        const content: HTMLDivElement | null = itemElement.querySelector(
          '[data-accordion-item-content]'
        );

        if (titleElement && content) {
          itemElement.classList.toggle(TOGGLE_CLASS);
        }
      });
    });
  });
};

export default Accordion;
